import { abacGuardService } from "../abac.guard.service";
import { ADMIN_ABAC_PERMISSION } from "../../constants/admin-abac-permission.const";
import { REACT_APP_ADMIN_URL } from "../../../../../constants/env";

const PLATFORM_ADMIN_PREFIX = /^\/admin/;

export function getAdminRedirectUrl(pathname: string, search: string): string | null {
  if (!REACT_APP_ADMIN_URL) {
    return null;
  }

  const hasAdminAbacPermission = abacGuardService.can(ADMIN_ABAC_PERMISSION.can, ADMIN_ABAC_PERMISSION.model);
  if (!hasAdminAbacPermission) {
    return null;
  }

  const adminAppPath = pathname.replace(PLATFORM_ADMIN_PREFIX, "");
  return `${REACT_APP_ADMIN_URL}${adminAppPath}${search}`;
}
